import { useAppProvider } from "../AppProvider";

function useImageContext() {
  return useAppProvider()?.Image || {};
}

export { useImageContext };
